import {FILE_VIEWER_SET} from "../mutations/available";

export const fileViewerOpen = async ({commit, dispatch}, {source, title, mimeType, downloadFileName = null}) => {
    dispatch('startProgress', 'fileViewer.open', {
        root: true
    })

    commit(FILE_VIEWER_SET, {
        source,
        title,
        mimeType,
        downloadFileName
    })
}

export const fileViewerClose = async ({commit}) => {
    commit(FILE_VIEWER_SET, {
        source: null,
        title: null,
        mimeType: null,
        downloadFileName: null
    })
}